// extracted by css-extract-rspack-plugin
export default {"button":"Base_button__X3rvr","disabled":"Base_disabled__Kdve9"};